@if (length > 0) {
  <div class="layout">
    <button
      mat-button
      class="btn"
      [ngStyle]="pageIndex > 0 && textStyle"
      [disabled]="pageIndex == 0"
      (click)="goFirst()"
    >
      <i class="material-icons">first_page</i><span class="text">First</span>
    </button>
    <button
      mat-button
      class="btn"
      [ngStyle]="pageIndex > 0 && textStyle"
      [disabled]="pageIndex == 0"
      (click)="goPrev()"
    >
      <i class="material-icons">chevron_left</i><span class="text">Prev</span>
    </button>
    <mat-form-field class="field">
      <mat-select [(ngModel)]="pageIndex" (selectionChange)="onSelect()">
        @for (p of pageList; track p) {
          <mat-option [value]="p">{{ p + 1 }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button
      mat-button
      class="btn"
      [ngStyle]="pageIndex < pageList.length - 1 && textStyle"
      [disabled]="pageIndex >= pageList.length - 1"
      (click)="goNext()"
    >
      <span class="text">Next</span><i class="material-icons">chevron_right</i>
    </button>
    <button
      mat-button
      class="btn"
      [ngStyle]="pageIndex < pageList.length - 1 && textStyle"
      [disabled]="pageIndex >= pageList.length - 1"
      (click)="goLast()"
    >
      <span class="text">Last</span><i class="material-icons">last_page</i>
    </button>
  </div>
}
